import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5L6 6.5L11 1.5", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevron;
